export default __webpack_public_path__ + "static/media/VectorClose.beb415ba.svg";